import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {CompetitorCompetitionsApiModel} from "../../common/competitor/models/competitor-competitions.api-model";
import type {AthleteApiModel} from "../../common/athlete/athlete-api-model";
import {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";

export class EntitiesResponseApiModel extends BaseApiResponseModel {
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorCompetitionsApiModel>;
  athletes: Array<AthleteApiModel>;

  constructor(model: EntitiesResponseApiModel, request: BaseApiRequestModel) {

    super(model, request);

    this.countries = model.countries;
    this.sports = model.sports;
    this.competitions = model.competitions;
    this.competitors = model.competitors;
    this.athletes = model.athletes;
  }
}
